import React from "react";
import PropTypes from "prop-types";

import "./BadgeFolded.scss";

/* Folded Badge */
const BadgeFolded = (props) => {
    return (
        <div className="folded">
            <span className={props.className}>{props.label}</span>
        </div>
    );
}

BadgeFolded.defaultProps = {
    className: "bg-pink",
    label: "BETA"
}

BadgeFolded.propTypes = {
    label: PropTypes.string,
    className: PropTypes.string
}

export default BadgeFolded;